import { Loan } from "models/Loan";
import {
    React, RouteComponentProps,
    Formsy, form, formHelpers,
    i18n,
    observable, inject, observer,
    mui, ui, theme, styled, pr, Desktop, Mobile,
    helpers, config
} from "aaa";
import { AMOUNT_RANGE_STEP } from "../models/InterestRates";


type IProps = i18n.InjectedIntlProps & {
    loan: Loan;
};

const LEFT_COLUMN_WIDTH = "20%";
const RIGHT_COLUMN_WIDTH = "40%";

let __: any;

const sliderRootStyle = {
    marginTop: 15,
    // marginBottom: 50,
    width: "50%"
};

const sliderRootStyleMobile = {
    marginTop: 15,
    // marginBottom: 30,
    marginLeft: "auto",
    marginRight: "auto",
    width: "80%"
};

interface IState {
    amountTextValue: string;
    durationTextValue: string;
}


@i18n.injectIntl
@inject("loan")
@observer
export default class LoanCalculatorSlidersValues extends React.Component<IProps, IState> {

    @observable
    errorAmount?: string;

    @observable
    errorDuration?: string;

    constructor(props: IProps) {
        super(props);
        __ = i18n.bindStr(this.props.intl);

        this.state = {
            amountTextValue: props.loan.amount.toLocaleString("de"),
            durationTextValue: props.loan.durationInYears.toString()
        };
    }

    onAmountChange = (event: any, value: string) => {
        const amount = Number(value.replace(config.CURRENCY_THOUSANDS_SEPARATOR, "").replace(config.CURRENCY_DECIMAL_SEPARATOR, "."));

        if (value.length === 0) {
            this.errorAmount = __("error.formatInvalid");
        } else if (isNaN(amount)) {
            // Value is invalid
            this.errorAmount = __("error.formatInvalid");
            return;
        } else if (value.indexOf(config.CURRENCY_DECIMAL_SEPARATOR) >= 0 || !Number.isInteger(amount)) {
            // Value has cents
            this.errorAmount = __("error.noCentValues");
        } else {
            if (amount >= this.props.loan.minAmount &&
                amount <= this.props.loan.maxAmount) {

                this.props.loan.amount = amount;
                this.errorAmount = undefined;
            } else {
                // Value too big/small
                this.errorAmount = amount < this.props.loan.minAmount ? __("loan.amountTooSmall") : __("loan.amountTooBig");
            }
        }

        if (value) {
            this.setState({
                amountTextValue: amount.toLocaleString("de")
            });
        } else {
            this.setState({ amountTextValue: "" });
        }
    }

    onDurationChange = (event: any, value: string) => {

        const duration = Number(value);
        if (value.length === 0) {
            this.errorDuration = __("loan.durationError");
        } else if (isNaN(duration) ||
            duration !== parseInt(value, 10)) {
            this.errorDuration = __("error.formatInvalid");
        } else {
            if (duration >= this.props.loan.minDuration && duration <= this.props.loan.maxDuration) {
                this.errorDuration = undefined;
                this.props.loan.durationInYears = duration;
            } else {
                this.errorDuration = __("loan.durationError");
            }
        }
        this.setState({
            durationTextValue: value
        });
    }

    renderAmount() {
        return (
            <pr.HFlex style={{ marginBottom: theme.MARGIN }}>
                <div style={{ width: LEFT_COLUMN_WIDTH, marginTop: 10 }}>
                    <pr.LightText>{__("loan.amount")}</pr.LightText>
                    {/* tslint:disable-next-line:max-line-length */}
                    <pr.LightText style={{ marginTop: 10 }}>{__("loan.amountSubtitleValues", { minAmount: helpers.numberToCurrencyString(this.props.loan.minAmount, false) })}</pr.LightText>
                </div>

                <div style={{ marginLeft: theme.MARGIN, width: RIGHT_COLUMN_WIDTH }}>
                    <mui.TextField
                        hintText={__("loan.amountHint")}
                        required
                        onChange={this.onAmountChange}
                        defaultValue={this.props.loan.amount}
                        errorText={this.errorAmount}
                    />
                </div>
            </pr.HFlex>
        );
    }

    renderAmountSlider(style: any) {
        return (
            <pr.HFlex style={{ width: "100%", justifyContent: "center" }}>
                <pr.SliderLabelLeft>{this.props.loan.minAmount.toLocaleString(config.LOCALE)} {ui.__("euro")}</pr.SliderLabelLeft>
                <mui.Slider
                    min={this.props.loan.minAmount}
                    max={this.props.loan.maxAmount}
                    step={AMOUNT_RANGE_STEP}
                    value={this.props.loan.amount}
                    onChange={(event, value) => {
                        this.props.loan.amount = value;
                        this.onAmountChange(null, value.toString());
                    }}
                    style={{ ...style }}
                    sliderStyle={{ marginTop: 5 }}
                />
                <pr.SliderLabelRight>{this.props.loan.maxAmount.toLocaleString(config.LOCALE)} {ui.__("euro")}</pr.SliderLabelRight>
            </pr.HFlex>
        );
    }

    renderDurationSlider(style: any) {
        return (
            <pr.HFlex style={{ width: "100%", justifyContent: "center" }}>
                <pr.SliderLabelLeft>{helpers.numberToYearsString(this.props.loan.minDuration)}</pr.SliderLabelLeft>
                <mui.Slider
                    min={this.props.loan.minDuration}
                    max={this.props.loan.maxDuration}
                    step={1}
                    value={this.props.loan.durationInYears}
                    onChange={(event, value) => {
                        this.props.loan.durationInYears = value;
                        this.onDurationChange(null, value.toString());
                    }}
                    style={style}
                    sliderStyle={{ marginTop: 5 }}
                />
                <pr.SliderLabelRight>{helpers.numberToYearsString(this.props.loan.maxDuration)}</pr.SliderLabelRight>
            </pr.HFlex>
        );
    }

    renderAmountFieldWithSliderDesktop() {
        return (
            <div style={{ display: "flex", alignItems: "center", marginBottom: 20, marginTop: 40 }}>
                <div style={{ width: LEFT_COLUMN_WIDTH, alignSelf: "flex-start" }}>
                    <pr.LightText>{__("loan.amount")}</pr.LightText>
                    <pr.LightText>{__("loan.amountSubtitle")}</pr.LightText>
                </div>
                <div style={{ width: "80%", marginLeft: theme.MARGIN, display: "flex", alignItems: "center", flexDirection: "column" }}>
                    <mui.TextField
                        type={"tel"}
                        hintText={__("loan.amountHint")}
                        hintStyle={{ left: 5 }}
                        required
                        onChange={this.onAmountChange}
                        errorText={<div style={{ marginTop: 6, marginLeft: 5 }}>{this.errorAmount}</div>}
                        value={this.state.amountTextValue}
                        underlineShow={false}
                        inputStyle={{ textAlign: "center", border: "2px solid #005FA6", borderRadius: 8 }}
                        style={{ marginBottom: 16 }}

                    />
                    {this.renderAmountSlider(sliderRootStyle)}
                </div>
            </div>
        );
    }

    renderDurationFieldWithSliderDesktop() {
        return (
            <div style={{ display: "flex", alignItems: "center", marginBottom: 50, marginTop: 40 }}>
                <div style={{ width: LEFT_COLUMN_WIDTH, alignSelf: "flex-start" }}>
                    <pr.LightText>{__("loan.duration")}</pr.LightText>
                </div>
                <div style={{ width: "80%", marginLeft: theme.MARGIN, display: "flex", alignItems: "center", flexDirection: "column" }}>
                    <mui.TextField
                        hintText={__("loan.durationHint")}
                        hintStyle={{ left: 5 }}
                        required
                        onChange={this.onDurationChange}
                        errorText={<div style={{ marginTop: 6, marginLeft: 5 }}>{this.errorDuration}</div>}
                        value={this.state.durationTextValue}
                        underlineShow={false}
                        inputStyle={{ textAlign: "center", border: "2px solid #005FA6", borderRadius: 8 }}
                        style={{ marginBottom: 16 }}
                    />
                    {this.renderDurationSlider(sliderRootStyle)}
                </div>
            </div>
        );
    }

    renderAmountFieldWithSliderMobile() {
        return (
            <div style={{ display: "flex", alignItems: "center", marginBottom: 20, flexDirection: "column" }}>
                <div style={{ width: LEFT_COLUMN_WIDTH, alignSelf: "flex-start" }}>
                    <pr.LightText>{__("loan.amount")}</pr.LightText>
                    <pr.LightText>{__("loan.amountSubtitle")}</pr.LightText>
                </div>
                <div style={{ marginTop: 20, width: "80%", marginLeft: theme.MARGIN, display: "flex", alignItems: "center", flexDirection: "column" }}>
                    <mui.TextField
                        type={"tel"}
                        hintText={__("loan.amountHint")}
                        hintStyle={{ left: 5 }}
                        required
                        onChange={this.onAmountChange}
                        defaultValue={this.props.loan.amount}
                        errorText={<div style={{ marginTop: 6, marginLeft: 5 }}>{this.errorAmount}</div>}
                        value={this.state.amountTextValue}
                        underlineShow={false}
                        inputStyle={{ textAlign: "center", border: "2px solid #005FA6", borderRadius: 8 }}

                    />
                    {this.renderAmountSlider(sliderRootStyleMobile)}
                </div>
            </div>
        );
    }

    renderDurationFieldWithSliderMobile() {
        return (
            <div style={{ display: "flex", alignItems: "center", marginBottom: 50, flexDirection: "column" }}>
                <div style={{ width: LEFT_COLUMN_WIDTH, alignSelf: "flex-start" }}>
                    <pr.LightText>{__("loan.duration")}</pr.LightText>
                </div>
                <div style={{ marginTop: 20, width: "80%", marginLeft: theme.MARGIN, display: "flex", alignItems: "center", flexDirection: "column" }}>
                    <mui.TextField
                        hintText={__("loan.durationHint")}
                        hintStyle={{ left: 5 }}
                        required
                        onChange={this.onDurationChange}
                        defaultValue={this.props.loan.durationInYears}
                        errorText={<div style={{ marginTop: 6, marginLeft: 5 }}>{this.errorDuration}</div>}
                        value={this.state.durationTextValue}
                        underlineShow={false}
                        inputStyle={{ textAlign: "center", border: "2px solid #005FA6", borderRadius: 8 }}
                    />
                    {this.renderDurationSlider(sliderRootStyleMobile)}
                </div>
            </div>
        );
    }

    render() {
        return (
            <div>
                <Desktop>
                    {this.renderAmountFieldWithSliderDesktop()}
                    {this.renderDurationFieldWithSliderDesktop()}
                </Desktop>
                <Mobile>
                    {this.renderAmountFieldWithSliderMobile()}
                    {this.renderDurationFieldWithSliderMobile()}
                </Mobile>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/LoanCalculatorSlidersValues.tsx